import { Col, FormLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import FormGroup from 'react-bootstrap/FormGroup';
import StringInput from '../core/components/forms/StringInput';
import Can from '../permissions/abilities/Can';
import { AddressSuggestionsInput, PhoneInput } from '../core/components/forms';
import ContactPhoneField from './components/ContactPhoneField';

// interface ClientContactsProps {
//   data?: object
// }

const ClientContacts = (props) => {
  const {
    data,
  } = props;

  return (
    <Col md={ 12 }>
      <Can do='permissionUpdate' on='reference.person.card.contact.detail' passThrough>
        { can => (
          <Row>
            <Col md={ 12 }>
              <Row>
                <Col md={ 4 }>
                  <PhoneInput
                    name='phoneNumber'
                    placeholder='Моб. телефон'
                    label='Моб. телефон'
                    disabled
                  />
                </Col>
                <Col md={ 4 }>
                  <FormGroup className='has-float-label'>
                    <FormLabel>Адрес</FormLabel>
                    <AddressSuggestionsInput
                      name='address'
                      disabled={ !can }
                    />
                  </FormGroup>
                </Col>
                <Col md={ 4 }>
                  <Can do='available' on='reference.client.email' passThrough>
                    { can1 => (
                      <StringInput
                        name='email'
                        label='Email'
                        placeholder='Email'
                        disabled={ !can || (!can1 && !!data.id && !!data.email) }
                      />
                    ) }
                  </Can>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Row>
                    <Col md={ 12 }>
                      <FormLabel>Контактные телефоны</FormLabel>
                      <ul>
                        <ContactPhoneField
                          field='contactPhoneNumber1'
                          disabled={ !can }
                        />
                        <ContactPhoneField
                          field='contactPhoneNumber2'
                          disabled={ !can }
                        />
                      </ul>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        ) }
      </Can>
    </Col>
  );
};

const mapStateToProps = state => ({
  data: state.clients?.item,
});

export default connect(mapStateToProps)(ClientContacts);
